
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.88 6.92C20.56 6.6 20.16 6.41 19.69 6.41H19.52V4.44C19.52 3.95 19.32 3.47 18.98 3.13C18.64 2.79 18.16 2.59 17.67 2.59H5.37997C5.07997 2.59 4.80997 2.63 4.56997 2.71L4.37997 2.78C4.01997 2.91 3.68997 3.13 3.40997 3.41C2.87997 3.94 2.58997 4.64 2.58997 5.38V18.62C2.58997 19.36 2.87997 20.06 3.40997 20.59C3.92997 21.11 4.64997 21.41 5.37997 21.41H19.56C20.06 21.41 20.52 21.22 20.88 20.87C21.22 20.51 21.41 20.05 21.41 19.56V8.22C21.41 7.73 21.21 7.26 20.88 6.92ZM4.68997 4.68C4.86997 4.5 5.12997 4.39 5.37997 4.39L17.72 4.34L17.77 6.37H5.37997C5.12997 6.37 4.86997 6.26 4.68997 6.08C4.49997 5.89 4.38997 5.64 4.38997 5.38C4.38997 5.12 4.49997 4.87 4.68997 4.68ZM5.37997 19.61C5.12997 19.61 4.86997 19.5 4.68997 19.32C4.49997 19.13 4.38997 18.88 4.38997 18.62V8L4.44997 8.02L4.54997 8.05C4.63997 8.08 4.72997 8.1 4.81997 8.12L4.96997 8.15H5.14997L5.37997 8.17L19.61 8.12L19.66 19.61H5.37997Z","fill":"#16171F"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.41 8.22V19.56C21.41 20.05 21.22 20.51 20.88 20.87C20.52 21.22 20.06 21.41 19.56 21.41H5.37997C4.64997 21.41 3.92997 21.11 3.40997 20.59C2.87997 20.06 2.58997 19.36 2.58997 18.62V8.15C2.58997 7.17 3.38997 6.37 4.36997 6.37H19.52V6.42H19.69C20.16 6.41 20.56 6.6 20.88 6.92C21.21 7.26 21.41 7.73 21.41 8.22Z","fill":"#5D5CFD"}}),_c('path',{attrs:{"d":"M16.79 15.17C17.4969 15.17 18.07 14.5969 18.07 13.89C18.07 13.1831 17.4969 12.61 16.79 12.61C16.0831 12.61 15.51 13.1831 15.51 13.89C15.51 14.5969 16.0831 15.17 16.79 15.17Z","fill":"white"}})])
          )
        }
      }
    